{
  "possibleTypes": {
    "AcceptInvitationResponse": [
      "AcceptInvitationResult",
      "GenericError"
    ],
    "AddFirebaseUidToUserResult": [
      "AddFirebaseUidToUser",
      "GenericError"
    ],
    "AddManagerInfoResult": [
      "GenericError",
      "RefetchTokenError",
      "SignUpData"
    ],
    "AdminUserBase": [
      "AdminUser",
      "CurrentAdminUser"
    ],
    "AfterLoginUserActionResult": [
      "AfterLoginAction",
      "GenericError"
    ],
    "AppUser": [
      "Reviewer",
      "Storymaker"
    ],
    "AppUserInterface": [
      "Reviewer",
      "Storymaker"
    ],
    "AppUserPackageRemoveResult": [
      "GenericError",
      "OperationResult"
    ],
    "AppUserPackageUploadStatusUpdateResult": [
      "AppUserUpload",
      "GenericError"
    ],
    "ApplyCouponCodeResult": [
      "CouponApplicationResult",
      "RefetchTokenError"
    ],
    "AssetUploadPartListResult": [
      "AssetUploadPartList",
      "GenericError"
    ],
    "AssignTemplatesToFilmingGroupResult": [
      "FilmingGroup",
      "GenericError"
    ],
    "BaseError": [
      "GenericError",
      "OutdatedDataError",
      "RefetchTokenError",
      "ValidationError"
    ],
    "CancelAdminUserInvitationResult": [
      "GenericError",
      "OutdatedDataError"
    ],
    "ChapterResult": [
      "Chapter",
      "ValidationError"
    ],
    "CompleteAssetUploadResult": [
      "CompleteAssetUpload",
      "GenericError"
    ],
    "CompleteResetPasswordResult": [
      "AdminUser",
      "ValidationError"
    ],
    "CreateAssetUploadIntentResult": [
      "AssetUploadIntent",
      "GenericError"
    ],
    "CreateFeedbackResult": [
      "GenericError",
      "VideoFeedback"
    ],
    "CreateMobilePackageResult": [
      "GenericError",
      "MobilePackagePayload"
    ],
    "CreateOrganizationResult": [
      "GenericError",
      "Organization"
    ],
    "CreatePresignedRequestForVideoAssetUploadResult": [
      "GenericError",
      "PresignedRequest",
      "ValidationError"
    ],
    "CreateRosterMappingResult": [
      "GenericError",
      "RosterMapping"
    ],
    "CreateTeleprompterScriptResult": [
      "GenericError",
      "TeleprompterScript",
      "ValidationError"
    ],
    "CreateTemplateVariableResult": [
      "GenericError",
      "TemplateVariable",
      "ValidationError"
    ],
    "CreateVideoResult": [
      "ValidationError",
      "Video"
    ],
    "CurrentAdminUserResult": [
      "CurrentAdminUser",
      "GenericError",
      "SignUpData"
    ],
    "CurrentUserResult": [
      "CurrentAdminUser",
      "GenericError",
      "Reviewer",
      "SignUpData",
      "Storymaker"
    ],
    "DeleteAdminUserResult": [
      "AdminUser",
      "GenericError"
    ],
    "DeleteGeneratedContentResult": [
      "GenericError"
    ],
    "DeleteOrganizationResult": [
      "GenericError",
      "OrganizationDeletion",
      "OrganizationDeletionRefused"
    ],
    "DeleteResult": [
      "MediaAssetsDelete",
      "ValidationError"
    ],
    "DeleteRosterMappingResult": [
      "GenericError",
      "RosterMapping"
    ],
    "DeleteStorymakerResult": [
      "GenericError",
      "Storymaker"
    ],
    "DeleteTeleprompterScriptResult": [
      "GenericError",
      "TeleprompterScript"
    ],
    "DeleteTemplateVariableResult": [
      "GenericError",
      "TemplateVariable"
    ],
    "DeleteUtilizationReportResult": [
      "GenericError",
      "UtilizationReport"
    ],
    "DisableAdminUserResult": [
      "AdminUser",
      "GenericError"
    ],
    "DisableAppUserResult": [
      "GenericError",
      "Reviewer",
      "Storymaker"
    ],
    "DisableStorymakerResult": [
      "GenericError",
      "Storymaker"
    ],
    "EditStorymakerResult": [
      "GenericError",
      "Storymaker"
    ],
    "EditTemplateResult": [
      "GenericError",
      "Template"
    ],
    "EnableAdminUserResult": [
      "AdminUser",
      "GenericError"
    ],
    "EnableAppUserResult": [
      "GenericError",
      "Reviewer",
      "Storymaker"
    ],
    "EnableStorymakerResult": [
      "GenericError",
      "Storymaker"
    ],
    "FilmingGroupResult": [
      "FilmingGroup",
      "GenericError"
    ],
    "FinishSignUpResult": [
      "GenericError",
      "RefetchTokenError",
      "SignUpData"
    ],
    "GenerateContentAsyncResult": [
      "AsyncResult",
      "GenericError"
    ],
    "GeneratePromptStudioTakeResult": [
      "GenericError",
      "PromptStudioTake"
    ],
    "GenerateUtilizationReportResult": [
      "GenericError",
      "UtilizationReport"
    ],
    "GenerateVideoTranscriptResult": [
      "GenericError",
      "Transcript"
    ],
    "GeneratedContentResult": [
      "GeneratedContent",
      "GenericError"
    ],
    "GeneratedContentUpdateResult": [
      "GeneratedContent",
      "GenericError"
    ],
    "GetUserFromInvitationTokenResult": [
      "AdminUser",
      "GenericError"
    ],
    "InviteAdminUserResult": [
      "AdminUser",
      "GenericError"
    ],
    "InviteStorymakerResult": [
      "GenericError",
      "Storymaker"
    ],
    "InviteStorymakersWithReviewersResult": [
      "APIError",
      "GenericError",
      "Reviewer",
      "Storymaker"
    ],
    "MarkFeedbacksAsViewedResult": [
      "GenericError",
      "VideoFeedback"
    ],
    "MediaAssetResult": [
      "GenericError",
      "MediaAsset"
    ],
    "MediaAssetUpdateResult": [
      "MediaAsset",
      "ValidationError"
    ],
    "MediaAssetUploadSessionResult": [
      "GenericError",
      "UploadCredentials"
    ],
    "MediaAssetsResult": [
      "CreatedMediaAssetList",
      "ValidationError"
    ],
    "MigrateOrganizationResult": [
      "GenericError",
      "Organization"
    ],
    "MobileAssetUploadUrlResult": [
      "GenericError",
      "PresignedRequest"
    ],
    "MobileSignUpResult": [
      "GenericError",
      "MobileSignUpPayload"
    ],
    "MoveVideosResult": [
      "GenericError",
      "MovedVideos"
    ],
    "Node": [
      "AdminUser",
      "BrandAsset",
      "CaptureStep",
      "CaptureStepsList",
      "Chapter",
      "CurrentAdminUser",
      "EndCard",
      "FilmingGroup",
      "GeneratedContent",
      "MediaAsset",
      "MediaAssetSeo",
      "OauthInfo",
      "Organization",
      "Reviewer",
      "RosterMapping",
      "SignUpData",
      "Storymaker",
      "TeleprompterScript",
      "TeleprompterScriptStep",
      "Template",
      "TemplateVariable",
      "TemplateVariableValue",
      "TextCapture",
      "Transcript",
      "Video"
    ],
    "NodeWithStringID": [
      "AsyncResult",
      "ImageAsset",
      "JobError",
      "JobStatus",
      "TextAsset",
      "VideoAsset"
    ],
    "ProxyLinkPreviewResult": [
      "GenericError",
      "ProxyLinkPreview"
    ],
    "RebuildVideoResult": [
      "GenericError",
      "Video"
    ],
    "RecordPackageMetadataResult": [
      "GenericError",
      "RecordPackageMetadataPayload"
    ],
    "RecreateProxyLinksResult": [
      "GenericError",
      "VideoShareEntry"
    ],
    "RenameTemplateVariableResult": [
      "GenericError",
      "TemplateVariable",
      "ValidationError"
    ],
    "ReorderCaptureStepsResult": [
      "CaptureStep",
      "GenericError"
    ],
    "ReorderTextCapturesResult": [
      "GenericError",
      "TextCapture"
    ],
    "ResendAdminUserInvitationResult": [
      "GenericError",
      "OutdatedDataError"
    ],
    "RestoreOrganizationResult": [
      "GenericError",
      "OrganizationDeletion"
    ],
    "RestoreOriginalAssetResult": [
      "GenericError",
      "ImageAsset",
      "ValidationError",
      "VideoAsset"
    ],
    "RosterFieldStorageLocation": [
      "RosterFieldPropertyStorageLocation",
      "RosterFieldTopLevelLocation"
    ],
    "SavePromptStudioPromptResult": [
      "GenericError",
      "PromptStudioPrompt"
    ],
    "SaveVimeoCredentialsResult": [
      "GenericError",
      "Organization"
    ],
    "SaveYoutubeCredentialsResult": [
      "GenericError",
      "Organization"
    ],
    "SeoUpdateResult": [
      "MediaAssetSeo",
      "ValidationError"
    ],
    "SetAdminUserNextGenCsvUploadResult": [
      "AdminUser",
      "GenericError"
    ],
    "ShareVideoResult": [
      "GenericError",
      "VideoShareEntry"
    ],
    "SignUpManagerResult": [
      "GenericError",
      "SignUpData",
      "ValidationError"
    ],
    "StoreSubscriptionResult": [
      "GenericError",
      "RefetchTokenError",
      "SignUpData",
      "ValidationError"
    ],
    "StorymakerDeleteVideoResult": [
      "GenericError",
      "Video"
    ],
    "ToggleFreeVideoTemplateResult": [
      "FilmingGroup",
      "GenericError"
    ],
    "UnassignTemplatesFromFilmingGroupResult": [
      "FilmingGroup",
      "GenericError"
    ],
    "UpdateAdditionalEmailRecipientsResult": [
      "GenericError",
      "Organization"
    ],
    "UpdateAdminUserResult": [
      "AdminUser",
      "GenericError"
    ],
    "UpdateBrandColorsResult": [
      "BrandAsset",
      "ValidationError"
    ],
    "UpdateCaptureStepsListResult": [
      "CaptureStepsList",
      "GenericError"
    ],
    "UpdateMeResult": [
      "AdminUser",
      "GenericError"
    ],
    "UpdateMediaAssetStatus": [
      "GenericError",
      "MediaAsset"
    ],
    "UpdateRosterMappingResult": [
      "GenericError",
      "RosterMapping"
    ],
    "UpdateStorymakerResult": [
      "GenericError",
      "Storymaker"
    ],
    "UpdateSubscriptionTypeResult": [
      "GenericError",
      "Organization"
    ],
    "UpdateTeleprompterScriptResult": [
      "GenericError",
      "TeleprompterScript",
      "ValidationError"
    ],
    "UpdateTemplateVariableResult": [
      "GenericError",
      "TemplateVariable",
      "ValidationError"
    ],
    "UpdateTextCapturesResult": [
      "GenericError",
      "TextCapture"
    ],
    "UpdateVideoAssetsResult": [
      "APIError",
      "GenericError",
      "Video"
    ],
    "UpdateVideoStatusResult": [
      "GenericError",
      "Video"
    ],
    "UpdateVideoTextAssetsResult": [
      "GenericError",
      "Video"
    ],
    "UpdateVideoTranscriptionResult": [
      "GenericError",
      "Transcript"
    ],
    "UploadAssetResult": [
      "GenericError",
      "UploadAssetResponse",
      "ValidationError"
    ],
    "UploadStoryMakersResult": [
      "GenericError",
      "UploadStoryMakers"
    ],
    "UploadVideoAssetSuccessResult": [
      "GenericError",
      "ValidationError"
    ],
    "User": [
      "AdminUser",
      "CurrentAdminUser",
      "Reviewer",
      "Storymaker"
    ],
    "UserDeleteResult": [
      "DeletedUser",
      "GenericError"
    ],
    "UserLoginAction": [
      "GenericError",
      "LoginAction"
    ],
    "UserLoginActionResult": [
      "GenericError",
      "LoginAction"
    ],
    "UserLoginTokenActionResult": [
      "GenericError",
      "LoginToken"
    ],
    "UserPreLoginValidateResult": [
      "GenericError",
      "UserPreLoginValidate"
    ],
    "VerifyMobilePackageResult": [
      "GenericError",
      "MobilePackageVerification"
    ],
    "VideoUpdatesResult": [
      "MediaAsset",
      "Video",
      "VideoUpdateOperation"
    ],
    "addFirebaseUidToUserMobileResult": [
      "AddFirebaseUidToUserMobile",
      "GenericError"
    ],
    "exportPackagesAndAssetsResult": [
      "FileExport",
      "GenericError"
    ],
    "inviteAccountAdminUserResult": [
      "AdminUser",
      "GenericError"
    ],
    "requestOTPResult": [
      "GenericError",
      "VerifyOTP"
    ],
    "toggleAdminUserAIFeaturesResult": [
      "AdminUser",
      "GenericError"
    ],
    "toggleAdminUserDisabledResult": [
      "AdminUser",
      "GenericError"
    ],
    "updateSignupUserCustomPropertiesResult": [
      "GenericError",
      "Reviewer",
      "Storymaker"
    ],
    "updateUserCustomPropertiesAndSignupDataResult": [
      "GenericError",
      "Reviewer",
      "Storymaker"
    ],
    "upsertUserCustomPropertiesResult": [
      "GenericError",
      "Reviewer",
      "Storymaker"
    ],
    "userUpgradePasswordAndRoleResult": [
      "GenericError",
      "ValidationError"
    ],
    "verifyOTPResult": [
      "GenericError",
      "VerifyOTP"
    ]
  }
}